// 基础API前缀地址
export const apiPath = '/api-acc';
export const apiReport = '/api-lcp-report';
export const adscPath = '/api-adsc';
export const otpPath = '/api-otp';
export const lcsPath = '/api-lcs';
export const orderPath = '/api-lots';
export const authPath = '/api-auth';
export const msgPath = '/api-msg';
export const ossPath = '/api-oss';
export const dsPath = '/api-ds';
